import Immutable from 'seamless-immutable';
// ---- external imports ----

import Level from '~/lib/levels.json';
// ---- internal imports ----

import * as types from './actionTypes';
// ---- local imports ----

const initialState = Immutable({
	number: 0,
	levelList: Level,
	story: '',
	featuresToUnlock: [],
	missions: [],
	isFirstAttemptInLevel: true,
});

export default function reduce(state = initialState, action = {}) {
	
	switch (action.type) {
	case types.LEVEL_CREATE_NEW_GAME:
	case types.LEVEL_LOAD_GAME:
	case types.LEVEL_COMPLETED:
		return state.merge({
			number: action.level,
			missions: action.missions,
			story: action.story,
			featuresToUnlock: action.featuresToUnlock,
			isFirstAttemptInLevel: action.isFirstAttemptInLevel,
		}, { deep: true });
	case types.LEVEL_UPDATE_MISSIONS:
	case types.LEVEL_CONTINUE_FAILED:
		return state.merge({
			missions: action.missions
		}, { deep: true });
	default:
		return state;
	}
}
